<mat-table
  [dataSource]="items"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.name }}
      </span>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
